import { Spin } from 'antd'
import { typeUserConst } from 'constant'
import useAuth from 'hooks/useAuth'
import React, { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { ScrollToTop } from 'utils/ScrollToTop'

const AuthLayout = () => {
  const { userType } = useAuth()
  if (userType === typeUserConst.UNDECIDED) {
    return <Navigate to={'/onboarding'} replace={true} />
  }
  return (
    <main className="flex flex-col gap-8 px-4 justify-center items-center xl:py-0 py-10 w-full min-h-screen">
      <ScrollToTop />
      <Suspense
        fallback={
          <div
            className="
        h-screen w-screen flex justify-center items-center">
            <Spin size="large" spinning={true}></Spin>
          </div>
        }>
        <Outlet />
      </Suspense>
    </main>
  )
}

export default AuthLayout
